const antiPassback = {
  title: 'Anti-passback',
  restriction_mode: {
    title: 'Modo de restricción',
    hard: 'Estricto',
    soft: 'Flexible',
    hard_helper:
      'Deniega el acceso cuando se detecta una violación de passback',
    soft_helper:
      'Registra la violación de passback pero igualmente concede el acceso',
  },
  user_exit_reset: {
    title: 'Restablecimiento de salida del usuario',
    delay_or_exit_reader: {
      title: 'Retardo o lector de salida',
      description:
        'Restablecer al presentar la credencial en un lector periférico, o automáticamente tras un período de retraso.',
    },
    schedule_or_exit_reader: {
      title: 'Horario o lector de salida',
      description:
        'Restablecer al presentar la credencial en un lector periférico, o en los horarios programados.',
      info: 'El reinicio ocurre al inicio del horario.',
    },
    exit_reader_only: {
      title: 'SOLO lector de salida',
      description:
        'La ubicación del usuario solo se restablece cuando la credencial se presenta en un lector periférico.',
      warning: 'Seleccione al menos una puerta con un lector de salida.',
    },
  },
  exempted_users: {
    title: 'Usuarios exentos',
    description:
      'Los usuarios seleccionados están exentos de la aplicación del Anti-passback.',
  },
  peripheral_doors: {
    title: 'Puertas periféricas',
    description:
      'Las puertas seleccionadas aplicarán la configuración Anti-passback cuando esté habilitada.',
  },
  validation: {
    must_be_number: 'Debe ser un número',
    must_be_integer: 'Debe ser un entero',
    must_be_at_least: 'Debe ser al menos {{min}}',
    must_be_at_most: 'Debe ser como máximo {{max}}',
  },
  not_supported: {
    title: 'Función no compatible',
    description:
      'El firmware del controlador principal debe estar en la versión {{ minVersion }} o superior para utilizar Anti-passback. Actualice el firmware del controlador principal para acceder a esta función.',
  },
  firmware_requirement: 'Requisito de firmware',
};

export default antiPassback;
